import React, {useCallback, useEffect, useState} from "react";
import {
    Badge,
    Button,
    Card,
    ChoiceList,
    DataTable,
    DisplayText,
    Icon,
    Image,
    Loading,
    Page,
    Select,
    Spinner,
    TextField,
    TextStyle,
    Tooltip
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import Pagination from "@material-ui/lab/Pagination";
import {EditMajor,} from "@shopify/polaris-icons";
import NavigationLayout from "../../Components/NavigationLayout";
import {useNavigate} from "react-router-dom";

const ListAdminUsers = () => {
    const navigate = useNavigate();
    const perPage = 30;
    const [isLoading, setIsLoading] = useState(true);
    const [isListEmpty, setIsListEmpty] = useState(false);
    const [items, setItems] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [availability, setAvailability] = useState("");
    const [queryValue, setQueryValue] = useState("");
    const [page, setPage] = useState(1);
    const [sortState, setSortState] = useState("-id");
    const [accreditationTypes, setAccreditationTypes] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState('');


    const [filterId, setFilterId] = useState('');
    const [filterFirstName, setFilterFirstName] = useState('');
    const [filterLastName, setFilterLastName] = useState('');
    const [filterEmail, setFilterEmail] = useState('');
    const [selectedRole, setSelectedRole] = useState('');
    const [sortName, setSortName] = useState('id');
    const [sortDirection, setSortDirection] = useState('desc');


    const sortingColumnNames = ['id', 'first_name', 'last_name', 'email'];
    const handleChangePage = (event, value) => {
        setPage(value);
    };
// Updated handleSort function using column index
    const handleSort = (index) => {
        const newSortName = sortingColumnNames[index];
        const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';

        setSortName(newSortName);
        setSortDirection(newSortDirection);
    };
    const handleEdit = (e) => {
        navigate(`/admin/manage-admin-users/${e.currentTarget.id}`);
    };

    const getData = () => {
        setIsLoading(true);
        const filters = {
            id: filterId,
            first_name: filterFirstName,
            last_name: filterLastName,
            email: filterEmail,
            accreditation_type_id: selectedEvent,
            role_id: selectedRole,
        };

        const queryParams = Object.entries(filters)
            .filter(([key, val]) => val !== '')
            .map(([key, val]) => `filter[${key}]=${encodeURIComponent(val)}`)
            .join('&');

        axios
            .get(`admin/v1/management/users?per_page=${perPage}&page=${page}&sort=${sortName}&direction=${sortDirection}&${queryParams}`)
            .then((result) => {
                setIsLoading(false);
                // console.log(result.data.data);
                !result.data.data.data.length
                    ? setIsListEmpty(true)
                    : setIsListEmpty(false);

                setAccreditationTypes(result?.data?.accreditationTypes);
                setRoleList(result?.data?.roles);
                setTotalPages(Math.ceil(result.data.data.total / perPage));

                result?.data?.data?.data &&
                setItems(
                    result.data.data.data.map((item, index) => {
                        const labels = [...new Set(item.user_accreditation_types.map((t) => t.trim()))];

                        const displayLabels = labels.slice(0, 2).join(', ');
                        const extraCount = labels.length - 2;

                        const tooltipContent = (
                            <ul>
                                {labels.map((label, index) => (
                                    <li key={index}>{label}</li>
                                ))}
                            </ul>
                        );
                        const displayText =
                            extraCount > 0 ? `${displayLabels} +${extraCount}` : displayLabels;

                        return [
                            <div className={`itemClick`}>{item.id}</div>,

                            <Tooltip content={tooltipContent}>
                                <div
                                    className="itemClick"
                                    style={{
                                        maxWidth: '200px',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                    }}
                                >
                                    {displayText}
                                </div>
                            </Tooltip>,

                            item?.first_name && (
                                <div className={`itemClick`}>{item?.first_name}</div>
                            ),
                            item?.last_name && (
                                <div className={`itemClick`}>{item?.last_name}</div>
                            ),
                            item?.email && <div className={`itemClick`}>{item?.email}</div>,
                            item?.roles[0] && (
                                <div className={`itemClick`}>
                                    <Badge>{item?.roles[0].name}</Badge>
                                </div>
                            ),
                            <div className={`itemClick`}>
                                <Button onClick={handleEdit} id={item.id}>
                                    <Icon source={EditMajor}></Icon>
                                </Button>
                            </div>,
                        ];
                    })
                );
            })
            .catch((err) => setIsLoading(false));
    };

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            getData();
        }, 300);

        return () => clearTimeout(delayDebounce);
    }, [filterId, filterFirstName, filterLastName, filterEmail, queryValue, availability, selectedEvent, selectedRole, page, sortState, sortName, sortDirection]);

    function handleFiltersQueryChange(queryValue) {
        setQueryValue(queryValue);
    }

    function handleAvailabilityChange(availability) {
        setAvailability(availability);
    }

    const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
    const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
    const handleFiltersClearAll = useCallback(() => {
        handleAvailabilityRemove();
        handleQueryValueRemove();
    }, [handleAvailabilityRemove, handleQueryValueRemove]);

    const filters = [
        {
            key: "availability",
            label: "Filter by",
            filter: (
                <ChoiceList
                    title="Filter by"
                    titleHidden
                    choices={[
                        {label: "ID", value: "id"},
                        {label: "First Name", value: "first_name"},
                        {label: "Last Name", value: "last_name"},
                    ]}
                    selected={availability || []}
                    onChange={handleAvailabilityChange}
                />
            ),
            shortcut: true,
        },
    ];

    const appliedFilters = [];
    if (!isEmpty(availability)) {
        const key = "availability";
        appliedFilters.push({
            key,
            label: disambiguateLabel(key, availability),
            onRemove: handleAvailabilityRemove,
        });
    }

    const loadingMarkup = isLoading ? <Loading/> : null;
    const emptyState = isListEmpty ? (
        <div
            style={{
                display: "flex",
                justifyContent: "middle",
                flexDirection: "column",
                alignItems: "center",
            }}
        >
            <div style={{width: "25%"}}>
                <Image src={emptyListImage}></Image>
            </div>
            <DisplayText size="small">No results found</DisplayText>
            <br/>
        </div>
    ) : (
        isLoading && (
            <div className="spinnerContainer">
                <div className="vertical-center">
                    <Spinner size="large"/>
                </div>
            </div>
        )
    );

    const handleEventFilter = (value) => {
        setSelectedEvent(value);
        // Optional: trigger filter or API fetch with selected event
    };

    return (
        <NavigationLayout>
            <Page
                fullWidth
                // title="Users Management"
                primaryAction={{
                    content: <p style={{color: "white"}}>Add User</p>,
                    url: "/admin/manage-admin-users/new",
                }}
                // breadcrumbs={[{ url: "/admin/content" }]}
            >
                <Card>
                    {loadingMarkup}
                    {/*<Card.Section>*/}
                    {/*    <Filters*/}
                    {/*        queryValue={queryValue}*/}
                    {/*        filters={filters}*/}
                    {/*        appliedFilters={appliedFilters}*/}
                    {/*        onQueryChange={handleFiltersQueryChange}*/}
                    {/*        onQueryClear={handleQueryValueRemove}*/}
                    {/*        onClearAll={handleFiltersClearAll}*/}
                    {/*    />*/}
                    {/*</Card.Section>*/}
                    <DataTable
                        columnContentTypes={["text", "text", "text", "text"]}
                        headings={[
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    width: '100px',
                                    padding: '1.6rem',
                                    cursor: 'pointer'
                                }}
                                onClick={() => handleSort(0)}
                            >
                                <div onClick={(e) => e.stopPropagation()}>
                                    <TextField
                                        label="ID"
                                        labelHidden
                                        placeholder="ID"
                                        value={filterId}
                                        onChange={setFilterId}
                                        autoComplete="off"
                                    />
                                </div>
                                <span style={{color: '#ccc', marginLeft: 4}}>
                                    {sortName === 'id' ? sortDirection === 'asc' ? '↑' : '↓' : '↕'}
                                </span>
                            </div>,
                            <div style={{width: '200px', padding: '0.5rem'}}>
                                <Select
                                    label="Event"
                                    labelHidden
                                    options={[
                                        {label: 'Select Event', value: ''},
                                        ...accreditationTypes.map((event) => ({
                                            label: event.details?.label || 'N/A',
                                            value: String(event.id),
                                        })),
                                    ]}
                                    onChange={(value) => {
                                        setSelectedEvent(value);
                                        getData();
                                    }}
                                    value={String(selectedEvent)}
                                />
                            </div>,
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    width: '200px',
                                    padding: '0.5rem',
                                    cursor: 'pointer'
                                }}
                                onClick={() => handleSort(1)}
                            >
                                <div onClick={(e) => e.stopPropagation()}>
                                    <TextField
                                        label="First Name"
                                        labelHidden
                                        placeholder="First Name"
                                        value={filterFirstName}
                                        onChange={setFilterFirstName}
                                        autoComplete="off"
                                    />
                                </div>
                                <span style={{color: '#ccc', marginLeft: 4}}>
                                    {sortName === 'first_name' ? sortDirection === 'asc' ? '↑' : '↓' : '↕'}
                                </span>
                            </div>,
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    width: '150px',
                                    padding: '0.5rem',
                                    cursor: 'pointer'
                                }}
                                onClick={() => handleSort(2)}
                            >
                                <div onClick={(e) => e.stopPropagation()}>
                                    <TextField
                                        label="Last Name"
                                        labelHidden
                                        placeholder="Last Name"
                                        value={filterLastName}
                                        onChange={setFilterLastName}
                                        autoComplete="off"
                                    />
                                </div>
                                <span style={{color: '#ccc', marginLeft: 4}}>
                                    {sortName === 'last_name' ? sortDirection === 'asc' ? '↑' : '↓' : '↕'}
                                </span>
                            </div>,
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    width: '150px',
                                    padding: '0.5rem',
                                    cursor: 'pointer'
                                }}
                                onClick={() => handleSort(3)}
                            >
                                <div onClick={(e) => e.stopPropagation()}>
                                    <TextField
                                        label="Email"
                                        labelHidden
                                        placeholder="Email"
                                        value={filterEmail}
                                        onChange={setFilterEmail}
                                        autoComplete="off"
                                    />
                                </div>
                                <span style={{color: '#ccc', marginLeft: 4}}>
                                    {sortName === 'email' ? sortDirection === 'asc' ? '↑' : '↓' : '↕'}
                                </span>
                            </div>,
                            <div style={{width: '200px', padding: '0.5rem'}}>
                                <Select
                                    label="Role"
                                    labelHidden
                                    options={[
                                        {label: 'Select Role', value: ''},
                                        ...Object.entries(roleList).map(([id, name]) => ({label: name, value: id}))
                                    ]}
                                    onChange={(value) => {
                                        setSelectedRole(value);
                                        getData();
                                    }}
                                    value={String(selectedRole)}
                                />
                            </div>,
                            <TextStyle variation="strong"></TextStyle>,
                        ]}
                        rows={items}
                        sortable={[false, false, false, false, false, false]}
                        defaultSortDirection="descending"
                        initialSortColumnIndex={0}
                        onSort={handleSort}
                        verticalAlign="middle"
                    />

                    {emptyState}
                </Card>
                {totalPages >= 2 && (
                    <div
                        style={{
                            paddingTop: "10px",
                            textAlign: "center",
                            paddingBottom: "10px",
                        }}
                    >
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={handleChangePage}
                            size="large"
                        />
                    </div>
                )}
            </Page>
        </NavigationLayout>
    );

    function disambiguateLabel(key, value) {
        switch (key) {
            case "taggedWith":
                return `Tagged with ${value}`;
            case "availability":
                return `Filter by ${value}`;
            // case "productType":
            //   return value.join(", ");
            default:
                return value;
        }
    }

    function isEmpty(value) {
        if (Array.isArray(value)) {
            return value.length === 0;
        } else {
            return value === "" || value == null;
        }
    }
};

export default ListAdminUsers;
